import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { FeedbackTypeListPage } from '@/features/feedbackTypes/pages/FeedbackTypeListPage';
import { listSearchSchema } from '@/utils/listSearch';

export const Route = createFileRoute('/_auth/settings/feedback-types')({
  validateSearch: listSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Feedback Types">
      <Suspense fallback={<PageLoader />}>
        <FeedbackTypeListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
